export type Attachment = 'top' | 'right' | 'bottom' | 'left';

export const getAttachmentBorderRadius = (attachment: Attachment | undefined, radius: string) => {
    switch (attachment) {
        case 'top':
            return `0 0 ${radius} ${radius}`;
        case 'right':
            return `${radius} 0 0 ${radius}`;
        case 'bottom':
            return `${radius} ${radius} 0 0`;
        case 'left':
            return `0 ${radius} ${radius} 0`;
        default:
            return radius;
    }
};
